<template>
  <div>
    <div class="navigation-actions catalog__navigation-actions sml-hide" :class="{'empty_tree':!('tree' in this.$store.getters.page)}">

      <div class="navigation-actions__item00">
        <div class="dropdown00 dropdown_theme_list00" data-dropdown="droped">
          <div class="dropdown__title00" v-if="'tree' in this.$store.getters.page">
            <label class="checkbox checkbox_theme_bordered">
              <input type="checkbox" name="hide_sub_folders"
                     class="checkbox__input"
                     v-model="isShowSubMenuTree"
                     @click="switchTree()"
              >
              <span class="checkbox__value">Показать дерево разделов</span>
            </label>
          </div>
        </div>
      </div>

      <div class="navigation-actions__item">
        <div class="dropdown dropdown_theme_list" data-dropdown="droped">
          <div class="dropdown__title" @click="showDownload">
            <span class="dropdown__title-icon icon icon-download"></span>
            Скачать этот раздел каталога
          </div>
          <div class="dropdown__content" :class="{'open': isShowDownload}">
            <a :href="url"
               class="export-xls">В формате XLS</a>
            <a :href="urlWidthImage"
               class="export-xls">В формате XLS с картинками</a>
          </div>
        </div>
      </div>
    </div>

    <div class="submenu-tree"
         :class="{'open': isShowSubMenuTree}"
         v-if="'tree' in this.$store.getters.page && this.$store.getters.page.tree">
      <tree></tree>

    </div>

  </div>
</template>

<script>
import Tree from "./Tree.vue";

export default {
  name: "SubmenuTree",
  data: function () {
    return {
      isShowSubMenuTree: Boolean($cookies.get("isShowSubMenuTree")),
      isShowDownload: false,
      arRootSubSections: [],
      filterParams:'',
    }
  },
  components: {
    Tree
  },
  methods: {

    showDownload: function (){
      this.isShowDownload = !this.isShowDownload;
    },
    switchTree:  function(){
      this.isShowSubMenuTree = !this.isShowSubMenuTree;
      if (this.isShowSubMenuTree) {
        this.$cookies.set("isShowSubMenuTree", this.isShowSubMenuTree);
      } else {
        $cookies.remove("isShowSubMenuTree");
      }
    }
  },
  computed: {
    filter() {
      return this.$store.getters.settings.filter;
    },
    sectionId() {
      return this.$store.getters.page.id;
    },
    type() {
      var result = 'section';
      if ('q' in this.$route.query && this.$route.query.q){
        result = 'search';
      }

      return result;
    },
    fprop() {
      return this.$store.getters.page.fprop;
    },
    fval() {
      return this.$store.getters.page.fval;
    },
    fIncludeTransit(){
      return this.$store.getters.settings.filter.isTransitStorage;
    },
    url() {
      return '/ajax/download.php?type=' + this.type + '&id=' + this.sectionId + (this.fprop != '' ? ('&fprop=' + this.fprop + '&fval=' + this.fval ) : '') + '&fincludetransit=' + (this.fIncludeTransit ? 'Y':'N') + (this.$route.query.q ? ('&q=' + this.$route.query.q) : '') + this.filterParams;
    },
    urlWidthImage() {
      return '/ajax/download.php?type=' + this.type + '&image=y&id=' + this.sectionId + (this.fprop != '' ? ('&fprop=' + this.fprop + '&fval=' + this.fval ) : '') + '&fincludetransit=' + (this.fIncludeTransit ? 'Y':'N') +  (this.$route.query.q ? ('&q=' + this.$route.query.q) : '');
    }
  },
  watch: {
    filter(val) {
      this.filterParams = "&filter=" + JSON.stringify(val);
    }
  }
}
</script>

<style scoped>
  @media screen and (max-width: 1019px){
    .catalog__navigation-actions.empty_tree{
      display: none;
    }
  }

</style>